import { render, staticRenderFns } from "./MeasureListForCreate.vue?vue&type=template&id=395c5974&"
import script from "./MeasureListForCreate.vue?vue&type=script&lang=js&"
export * from "./MeasureListForCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports